/**
 * Service worker (cache offline do app). A versão nova fica esperando e vale ao
 * reabrir o app; `atualizarAgora()` aplica na hora (botão discreto na casca).
 */
import { createSignal } from 'solid-js'
import { registerSW } from 'virtual:pwa-register'

const [versaoNovaPronta, setVersaoNovaPronta] = createSignal(false)
export { versaoNovaPronta }

let aplicar: ((recarregar?: boolean) => Promise<void>) | null = null

export function iniciarPwa(): void {
  if (!('serviceWorker' in navigator)) return
  aplicar = registerSW({
    immediate: true,
    onNeedRefresh: () => setVersaoNovaPronta(true),
    // Procura versão nova a cada 30 min enquanto o app fica aberto o dia todo.
    onRegisteredSW: (_url, reg) => {
      if (reg) setInterval(() => void reg.update(), 30 * 60 * 1000)
    },
  })
}

export function atualizarAgora(): void {
  void aplicar?.(true)
}
